import * as luxon from 'luxon';
import * as buttons from 'smg/buttons';
import { GetCountryIDFromPhone } from 'smg/countries';
import { Child, GetChildren, GetLineItems, GetSizes, GetTypes } from 'smg/customer-api/lineitems';
import * as promos from 'smg/customer-api/promos';
import * as quoterequests from 'smg/customer-api/quoterequests';
import { Session } from 'smg/customer-api/session';
import { HandleRequestError } from 'smg/errors';
import { ReportValidity } from 'smg/form';
import * as phone from 'smg/phone';
import * as uploads from 'smg/uploads';
import { GetFirstAndLast } from 'smg/users';
import { Relref } from '../hugo';

declare interface myWindow extends Window {
    dataLayer: Record<string, unknown>[];

}
declare const window: myWindow;

export default async function main() {
    const $form = document.querySelector('#form') as HTMLFormElement;
    const $fieldset = $form.querySelector('#form-fieldset') as HTMLFieldSetElement;
    const $submitBtn = $form.querySelector('#submit-btn') as HTMLButtonElement;
    const $productSelect = $form.querySelector('#product-select') as HTMLSelectElement;
    const $dynamicInputs = $form.querySelector('#dynamic-inputs') as HTMLElement;
    const $quantity = $form.querySelector('#quantity') as HTMLInputElement;
    const $minQty = $form.querySelector('#min-qty') as HTMLElement;

    let childrenForReq: quoterequests.Child[] = [];
    let sizeForReq = '';
    let typeForReq = '';
    let width: number | undefined;
    let height: number | undefined;
    let $selectEls: (HTMLSelectElement | HTMLInputElement)[];
    let hasChildren: boolean;
    const extras: quoterequests.Extra[] = [];

    const $sizeDiv = document.createElement('div');
    $sizeDiv.classList.add('d-flex', 'flex-column', 'flex-sm-row');

    const products = await GetLineItems();
    for (const product of products) {
        if (product.quoteForm) {
            $productSelect.appendChild(createOption(product.pluralName));
        }
    }

    $productSelect.appendChild(createOtherOption());

    $productSelect.addEventListener('input', async () => {
        childrenForReq = [];
        sizeForReq = '';
        typeForReq = '';
        width = undefined;
        height = undefined;
        $dynamicInputs.innerHTML = '';

        const $typeSelect = document.createElement('select');
        $typeSelect.classList.add('form-control', 'form-select', 'my-2');
        $typeSelect.required = true;
        const $selectTypeOpt = createOption('Select a Type');
        $selectTypeOpt.value = '';
        $typeSelect.appendChild($selectTypeOpt);

        const $sizeSelect = document.createElement('select');
        $sizeSelect.classList.add('form-control', 'form-select', 'my-2', 'd-none');
        const $selectSizeOpt = createOption('Select a Size');
        $selectSizeOpt.value = '';
        $sizeSelect.appendChild($selectSizeOpt);
        $sizeSelect.addEventListener('change', () => {
            sizeForReq = $sizeSelect.value;
        });

        createSizesDivs();

        if ($productSelect.value === 'Other') {
            const $otherInput = createOtherInput(undefined, 'product');
            $otherInput.required = true;

            $dynamicInputs.appendChild($otherInput);
            $dynamicInputs.appendChild($sizeDiv);
        } else if ($productSelect.value) {
            const types = await GetTypes($productSelect.value);
            for (const type of types) {
                $typeSelect.appendChild(createOption(type.name));
            }
            $typeSelect.appendChild(createOtherOption());
            $dynamicInputs.appendChild($typeSelect);
            $typeSelect.addEventListener('change', async () => {
                if ($typeSelect.value === 'Other') {
                    otherTypeSelected($typeSelect, $sizeSelect);
                } else {
                    typeSelected($typeSelect, $sizeSelect);
                }
                await typeSelectChange($productSelect.value, $typeSelect, $sizeSelect);
            });

            $dynamicInputs.appendChild($sizeSelect);

            $selectEls = await getSpecifiedChildren($productSelect.value);
            if ($selectEls) {
                hasChildren = true;
            } else {
                hasChildren = false;
            }
            for (const $el of $selectEls) {
                const $selectDiv = document.createElement('div') as HTMLElement;
                $selectDiv.classList.add('d-flex', 'flex-column', 'my-2');
                $selectDiv.appendChild(createLabel($el.name));
                $selectDiv.appendChild($el);
                $dynamicInputs.appendChild($selectDiv);
            }
        } else {
            childrenForReq = [];
            sizeForReq = '';
            typeForReq = '';
            width = undefined;
            height = undefined;
            $dynamicInputs.innerHTML = '';
        }

        if (!$productSelect.value) {
            $minQty.textContent = '';
            $quantity.value = '';
        } else {
            switch ($productSelect.value) {
            case 'Patches':
            case 'Lapel Pins':
            case 'Buttons':
            case 'Charms':
            case 'Key Chains':
            case 'Lanyards':
                $quantity.value = '100';
                break;
            default:
                $quantity.value = '50';
            }
            $minQty.textContent = `(Minimum quantity is ${$quantity.value})`;
        }
    });

    const $name = document.querySelector('#name') as HTMLInputElement;
    const $company = document.querySelector('#company') as HTMLInputElement;
    const $phone = document.querySelector('#phone') as HTMLInputElement;
    const $sms = document.querySelector('#sms-opt-in') as HTMLInputElement;
    const $email = document.querySelector('#email') as HTMLInputElement;
    const $dateNeeded = document.querySelector('#date-needed') as HTMLInputElement;
    const $notes = document.querySelector('#notes') as HTMLTextAreaElement;
    const $project = document.querySelector('#nickname') as HTMLInputElement;
    const $industry = document.querySelector('#industry-select') as HTMLSelectElement;
    const $budget = document.querySelector('#budget') as HTMLInputElement;
    const $promo = document.querySelector('#referral-code') as HTMLInputElement;
    const promoInput = new promos.Input($promo, { $email });

    const p = new phone.Phone($phone);

    const upload = document.getElementById('upload') as HTMLLabelElement;
    const u = new uploads.Uploader(upload);

    $form.noValidate = true;
    $form.addEventListener('submit', async e => {
        e.preventDefault();

        if (hasChildren) {
            childrenForReq = createChildParam($selectEls);
        }

        const currDate = luxon.DateTime.now().toISODate();
        $dateNeeded.min = currDate;

        await promoInput.Check();

        if (!ReportValidity($form)) {
            return false;
        }

        if ($industry.value) {
            extras.push({
                name: 'Industry',
                value: $industry.value,
            });
        }

        const $widthVal = document.querySelector('#width-input') as HTMLInputElement;
        const $heightVal = document.querySelector('#height-input') as HTMLInputElement;

        if ($widthVal) {
            if ($widthVal.value) {
                width = parseInt($widthVal.value, 10);
            }
        }

        if ($heightVal) {
            if ($heightVal.value) {
                height = parseInt($heightVal.value, 10);
            }
        }

        buttons.Start($submitBtn);
        $fieldset.disabled = true;

        void quoterequests.NewQuoteRequest({
            company: $company.value,
            email: $email.value,
            name: $name.value,
            phone: p,
            countryID: await GetCountryIDFromPhone(p),
            children: childrenForReq,
            lineItem: $productSelect.value === 'Other' ? (document.querySelector('#other-product-input') as HTMLInputElement).value : $productSelect.value,
            dateNeeded: String($dateNeeded.value),
            notes: $notes.value,
            project: $project.value,
            quantity: parseInt($quantity.value, 10),
            size: sizeForReq || undefined,
            width: width ? width : undefined,
            height: height ? height : undefined,
            type: typeForReq,
            uploader: u,
            extras,
            budget: parseFloat($budget.value),
            promo: $promo.value,
            sms: $sms.checked,
        }).then(async quoteRequest => {
            const sess = await Session().catch(() => undefined);
            const dataLayer = ((window.top as myWindow) || window).dataLayer || [];
            const { firstName, lastName } = GetFirstAndLast(String($name.value));
            dataLayer.push({
                'event': 'hugo-iframe-quote-request-form-success',
                'userData': {
                    'email': sess?.email || $email.value,
                    'phone': sess?.phone || await p.Format(),
                    'firstName': sess?.firstName || firstName,
                    'lastName': sess?.lastName || lastName,
                },
                'transactionId': quoteRequest.id,
                'total': quoteRequest.quotes?.[0].cachedTotal,
            });

            (window.top || window).location.href = `${Relref('/quote/received')}?ref=${encodeURIComponent((window.top || window).location.href)}`;
        }).catch(err => {
            HandleRequestError(err);
            $fieldset.disabled = false;
            buttons.Stop($submitBtn);
        });
    });

    function createSizesDivs() {
        $sizeDiv.innerHTML = '';

        const $widthDiv = document.createElement('div');
        const $widthLabel = document.createElement('label');
        const $widthInput = document.createElement('input');
        $widthDiv.classList.add('w-100', 'w-sm-50', 'w-lg-25');
        $widthLabel.setAttribute('for', 'width-input');
        $widthLabel.textContent = 'Desired Width (in inches):';
        $widthInput.classList.add('form-control', 'my-2');
        $widthInput.id = 'width-input';
        $widthInput.type = 'number';
        $widthInput.required = true;
        $widthInput.min = '0';
        $widthDiv.appendChild($widthLabel);
        $widthDiv.appendChild($widthInput);

        const $heightDiv = document.createElement('div');
        $heightDiv.classList.add('mx-sm-2');
        const $heightLabel = document.createElement('label');
        const $heightInput = document.createElement('input');
        $heightDiv.classList.add('w-100', 'w-sm-50', 'w-lg-25');
        $heightLabel.setAttribute('for', 'height-input');
        $heightLabel.textContent = 'Desired height (in inches):';
        $heightInput.classList.add('form-control', 'my-2');
        $heightInput.id = 'height-input';
        $heightInput.type = 'number';
        $heightInput.required = true;
        $heightInput.min = '0';
        $heightDiv.appendChild($heightLabel);
        $heightDiv.appendChild($heightInput);

        $sizeDiv.appendChild($widthDiv);
        $sizeDiv.appendChild($heightDiv);
    }
    function createChildParam($els: (HTMLSelectElement | HTMLInputElement)[]): quoterequests.Child[] {
        const children: quoterequests.Child[] = [];

        for (const $el of $els) {
            let child: quoterequests.Child;
            if ($el.value === 'Other') {
                const $targetInput = document.querySelector(`#other-${$el.id}-input`) as HTMLInputElement;
                child = {
                    child: $el.name,
                    option: $targetInput.value,
                };
            } else if (!$el.value) {
                child = {
                    child: $el.name,
                    option: 'Not Selected',
                };
            } else {
                child = {
                    child: $el.name,
                    option: $el.value,
                };
            }
            children.push(child);
        }
        return children;
    }
    async function getSpecifiedChildren(productType: string): Promise<(HTMLSelectElement | HTMLInputElement)[]> {
        const selectEls: (HTMLSelectElement | HTMLInputElement)[] = [];
        let children = await GetChildren(productType);
        children = children.filter(child => child.quoteForm);

        for (const child of children) {
            let $el: HTMLSelectElement | HTMLInputElement;
            if (child.name === 'Lanyard Color' || child.name === 'Imprint Color') {
                $el = document.createElement('input');
                $el.setAttribute('type', 'color');
                $el.classList.add('form-control-color', 'form-control');
                $el.id = child.id;
                $el.name = child.name;
            } else {
                $el = document.createElement('select');
                $el.classList.add('form-control', 'form-select', 'mt-1');
                $el.id = child.id;
                $el.name = child.name;
                const $selectOpt = createOption(`Select ${child.name}`);
                $selectOpt.value = '';
                $el.appendChild($selectOpt);

                const optTypes = child.options;
                for (const optType of optTypes) {
                    $el.appendChild(createOption(optType.name));
                }
                $el.appendChild(createOtherOption());
                $el.addEventListener('change', () => {
                    const $otherInputEl = document.querySelector(`#other-${child.id}-input`) as HTMLInputElement;
                    if ($el.value === 'Other') {
                        if ($otherInputEl) {
                            $otherInputEl.disabled = false;
                            $otherInputEl.classList.remove('d-none');
                        } else {
                            if ($el.parentElement) {
                                $dynamicInputs.insertBefore(createOtherInput(child), $el.parentElement?.nextElementSibling);
                            }
                        }
                    } else if ($otherInputEl) {
                        if ($otherInputEl.nextElementSibling) {
                            if ($otherInputEl.nextElementSibling?.classList.contains('invalid-feedback')) {
                                $otherInputEl.classList.remove('is-invalid');
                                $otherInputEl.nextElementSibling.remove();
                            }
                        }
                        $otherInputEl.disabled = true;
                        $otherInputEl.classList.add('d-none');
                    }
                });
            }
            selectEls.push($el);
        }
        return selectEls;
    }
    function createLabel(labelFor: string) {
        const $labelEl = document.createElement('label');
        $labelEl.textContent = `Select your ${labelFor}`;
        $labelEl.setAttribute('for', labelFor);
        return $labelEl;
    }

    async function typeSelectChange(productType: string, $typeSelectEl: HTMLSelectElement, $sizeSelectEl: HTMLSelectElement) {
        $sizeSelectEl.innerHTML = '';
        const $newSizeSelectOpt = createOption('Select a Size');
        $newSizeSelectOpt.value = '';
        $sizeSelectEl.appendChild($newSizeSelectOpt);
        const sizes = await GetSizes(productType, $typeSelectEl.value);
        for (const size of sizes) {
            $sizeSelectEl.appendChild(createOption(size.name));
        }
    }
    function typeSelected($typeSelectEl: HTMLSelectElement, $sizeSelectEl: HTMLSelectElement) {
        $sizeDiv.remove();
        $sizeSelectEl.disabled = false;
        $sizeSelectEl.required = true;
        const $otherTypeInput = document.querySelector('#other-type-input') as HTMLInputElement;
        $sizeSelectEl.classList.remove('d-none');
        if ($otherTypeInput) {
            $otherTypeInput.remove();
        }
        typeForReq = $typeSelectEl.value;
    }
    function otherTypeSelected($typeSelectEl: HTMLSelectElement, $sizeSelectEl: HTMLSelectElement) {
        sizeForReq = '';
        $sizeSelectEl.disabled = true;
        $sizeSelectEl.classList.add('d-none');
        if ($sizeSelectEl.nextElementSibling?.classList.contains('invalid-feedback')) {
            $sizeSelectEl.nextElementSibling.remove();
        }
        if ($typeSelectEl.nextElementSibling) {
            $dynamicInputs.insertBefore($sizeDiv, $typeSelectEl.nextElementSibling);
        }
        const $otherTypeInput = createOtherInput(undefined, 'type');
        $dynamicInputs.insertBefore($otherTypeInput, $typeSelectEl.nextElementSibling);
        $otherTypeInput.required = true;

        $otherTypeInput.addEventListener('input', () => {
            typeForReq = $otherTypeInput.value;
        });
    }
    function createOtherInput(child?: Child, inputType?: string): HTMLInputElement {
        const $otherInput = document.createElement('input');
        $otherInput.required = true;
        $otherInput.classList.add('form-control', 'my-2');
        $otherInput.type = 'text';
        if (!child) {
            if (inputType) {
                $otherInput.placeholder = 'Tell us what you\'re looking for';
                $otherInput.id = `other-${inputType}-input`;
            }
        } else {
            $otherInput.placeholder = `Tell us what ${child.name} you're looking for`;
            $otherInput.id = `other-${child.id}-input`;
        }
        return $otherInput;
    }
    function createOtherOption(): HTMLOptionElement {
        const otherOption = document.createElement('option');
        otherOption.textContent = 'Other';
        otherOption.value = 'Other';
        return otherOption;
    }
    function createOption(textContext: string): HTMLOptionElement {
        const option = document.createElement('option');
        option.textContent = textContext;
        return option;
    }
}